module.exports = __webpack_public_path__ + "static/media/knife-rain.1252258b.jpg";